export default {
    'new': {
        delivery: {
            checkbox: 'Доставка',

            form: {
                stockId: 'Склад формирования заказа в доставку',
                deliveryServiceId: 'Сервис доставки',
                clientName: 'Имя клиента для доставки',
                clientSurname: 'Фамилия клиента для доставки',
                clientPatronymic: 'Отчество клиента для доставки',
            },
        },

        deliveryAddress: {
            deliveryCity: 'Город доставки',
            deliveryIndex: 'Индекс доставки',
            deliveryStreet: 'Улица доставки',
            deliveryHouse: 'Дом доставки',
            deliveryApartment: 'Квартира доставки',
            deliveryRegion: 'Регион доставки',
            deliveryComment: 'Коммент доставки',
            deliveryPicPoint: 'Pic Point',
            deliveryKladrId: 'КЛАДР',
            lat: 'Широта (Lat)',
            lon: 'Долгота (Lon)',
        },

        'new': {
            danger:
        '* При изменении может измениться информация в доставке (тариф и сервис доставки)',
            button: 'Создать заказ',
            modalTitle: 'Успешное создание заказа',
            modalText: 'Создан заказ №',

            form: {
                orderSourceTypeId: 'Источник заказа',
                pfm: 'ПФМ',
                phone: 'Телефон',
                email: 'Email',
                commentClient: 'Комментарий клиента',
                payTypeId: '* Способ оплаты',
                customerRequests: 'Пожелания клиента',
                name: 'Имя клиента',
                userAuthorization: 'Авторизация',
                loyaltyCardNumber: 'Карта лояльности',
                lang: 'Язык сообщений',
                callbackUrl: 'Урл для коллбэков',
                externalUrl: 'Внешний урл',
                currencyId: 'Валюта',
            },
        },

        product: {
            title: 'Товар',
            buttonPrimary: 'Добавить товар',
            buttonAddSku: 'Добавить товар по SKU',

            form: {
                sku: 'Код товарной позиции',
                productName: 'Наименование',
                productWeight: 'Вес',
                productPrice: 'Цена',
                barcode: 'Баркод',
                actualBarcode: 'Реальный баркод',
                skuQuantity: 'Количество товарных позиций',
                productCommentClient: 'Комментарий к позиции от клиента',
                productProperties: 'Параметры',
                vat: 'НДС',
                pic: 'Картинка',
            },
        },
    },

    cancel: {
        label: 'ID заказа',
        button: 'Отменить',
        modalTitle: 'Успешная отмена заказа',
        modalText: 'Заказ № | отменен',
    },

    payStatus: {
        labelOrderId: 'ID заказа',
        labelStatus: 'Статус оплаты',
        labelOperation: 'Тип операции',
        button: 'Изменить',
        modalTitle: 'Успешное изменение статуса оплаты заказа',
        modalText: 'Статус оплаты заказа № | изменен',

        statuses: {
            text1: 'Ошибка',
            text2: 'Успех',
        },

        operations: {
            approved: 'Операция удержания (холдирования) суммы',
            deposited: 'Операция завершения',
            reversed: 'Операция отмены',
            refunded: 'Операция возврата',
            declinedByTimeout: 'Истекло время, отпущенное на оплату заказа',
        },
    },

    test: {
        title1: 'Создать',
        title2: 'Отменить',
        title3: 'Изменить',
    },
};